<template>
  <div class="main-header">
    <el-form :inline="true" @keyup.enter.native="print">
      <el-row>
        <el-col :span="2">
          <el-form-item label="">
            已选<span>{{count}}</span>场
          </el-form-item>
        </el-col>
<!--        <el-col :span="2">
          <el-form-item label="">
            玩法:{{zcountMap}}
          </el-form-item>
        </el-col>-->
        <el-col :span="6">
          <el-form-item label="过关方式">
            <el-radio-group v-model="ggType">
              <el-radio :label="0">M串N</el-radio>
              <el-radio :label="1">自由过关</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="">
            <el-date-picker
              v-model="selectDateTime"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="份数">
            <counter-input v-model="num" :options="[5, 10, 20]" :initialValue="1" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="倍数">
            <counter-input ref="counter" v-model="multiple" :options="[5, 10, 20, 25, 50]" :initialValue="1"/>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="投注金额:">
            <span><b>{{monery}}</b></span>元
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2" v-if="GToggle">
          <el-form-item label="">
            <el-checkbox v-model="selectedGToggle">单场({{dcount}})</el-checkbox>
          </el-form-item>
        </el-col>
        <div v-if="ggType == 0">
          <el-col :span="22">
            <el-form-item label="">
              <div v-if="count > 4 && (cpTypeName === '足球比分' || cpTypeName === '足球半全场胜平负')">
                <span>超过4场只能选择单关或自由过关进行计算！</span>
              </div>
              <div v-if="count > 6 && cpTypeName === '足球总进球数'">
                <span>超过6场只能选择单关或自由过关进行计算！</span>
              </div>
              <el-radio-group v-model="selectedMN">
              <div v-if="count == 2">
                <el-radio label="2x1">2x1</el-radio>
              </div>
              <div v-if="count == 3">
                <el-radio label="3x1">3x1</el-radio>
                <el-radio label="3x3">3x3</el-radio>
                <el-radio label="3x4">3x4</el-radio>
              </div>
              <div v-if="count == 4">
                <el-radio label="4x1">4x1</el-radio>
                <el-radio label="4x4">4x4</el-radio>
                <el-radio label="4x5">4x5</el-radio>
                <el-radio label="4x6">4x6</el-radio>
                <el-radio label="4x11">4x11</el-radio>
              </div>
              <div v-if="count == 5 && cpTypeName != '足球比分' && cpTypeName != '足球半全场胜平负'">
                <el-radio label="5x1">5x1</el-radio>
                <el-radio label="5x5">5x5</el-radio>
                <el-radio label="5x6">5x6</el-radio>
                <el-radio label="5x10">5x10</el-radio>
                <el-radio label="5x16">5x16</el-radio>
                <el-radio label="5x20">5x20</el-radio>
                <el-radio label="5x26">5x26</el-radio>
              </div>
              <div v-if="count == 6 && cpTypeName != '足球比分' && cpTypeName != '足球半全场胜平负'">
                <el-radio label="6x1">6x1</el-radio>
                <el-radio label="6x6">6x6</el-radio>
                <el-radio label="6x7">6x7</el-radio>
                <el-radio label="6x15">6x15</el-radio>
                <el-radio label="6x20">6x20</el-radio>
                <el-radio label="6x22">6x22</el-radio>
                <el-radio label="6x35">6x35</el-radio>
                <el-radio label="6x42">6x42</el-radio>
                <el-radio label="6x50">6x50</el-radio>
                <el-radio label="6x57">6x57</el-radio>
              </div>
              <div v-if="count == 7 && cpTypeName != '足球比分' && cpTypeName != '足球半全场胜平负' && cpTypeName != '足球总进球数'">
                <el-radio label="7x1">7x1</el-radio>
                <el-radio label="7x7">7x7</el-radio>
                <el-radio label="7x8">7x8</el-radio>
                <el-radio label="7x21">7x21</el-radio>
                <el-radio label="7x35">7x35</el-radio>
                <el-radio label="7x120">7x120</el-radio>
              </div>
              <div v-if="count == 8 && cpTypeName != '足球比分' && cpTypeName != '足球半全场胜平负' && cpTypeName != '足球总进球数'">
                <el-radio label="8x1">8x1</el-radio>
                <el-radio label="8x8">8x8</el-radio>
                <el-radio label="8x9">8x9</el-radio>
                <el-radio label="8x28">8x28</el-radio>
                <el-radio label="8x56">8x56</el-radio>
                <el-radio label="8x70">8x70</el-radio>
                <el-radio label="8x247">8x247</el-radio>
              </div>
            </el-radio-group>
            </el-form-item>
          </el-col>
        </div>
        <div v-else-if="ggType == 1">
          <el-col :span="22">
            <el-form-item label="">
              <div v-if="count == 2">
                <el-checkbox v-model="selectedG2">2关</el-checkbox>
              </div>
              <div v-if="count == 3">
                <el-checkbox v-model="selectedG2">2关</el-checkbox>
                <el-checkbox v-model="selectedG3">3关</el-checkbox>
              </div>
              <div v-if="count == 4">
                <el-checkbox v-model="selectedG2">2关</el-checkbox>
                <el-checkbox v-model="selectedG3">3关</el-checkbox>
                <el-checkbox v-model="selectedG4">4关</el-checkbox>
              </div>
              <div v-if="count == 5 && cpTypeName != '足球比分' && cpTypeName != '足球半全场胜平负'">
                <el-checkbox v-model="selectedG2">2关</el-checkbox>
                <el-checkbox v-model="selectedG3">3关</el-checkbox>
                <el-checkbox v-model="selectedG4">4关</el-checkbox>
                <el-checkbox v-model="selectedG5">5关</el-checkbox>
              </div>
              <div v-if="count > 4 && (cpTypeName == '足球比分' || cpTypeName == '足球半全场胜平负')">
                <el-checkbox v-model="selectedG2">2关</el-checkbox>
                <el-checkbox v-model="selectedG3">3关</el-checkbox>
                <el-checkbox v-model="selectedG4">4关</el-checkbox>
                <span>超过4场只能选择单关或自由过关进行计算</span>
              </div>
              <div v-if="count > 6 && cpTypeName == '足球总进球数'">
                <el-checkbox v-model="selectedG2">2关</el-checkbox>
                <el-checkbox v-model="selectedG3">3关</el-checkbox>
                <el-checkbox v-model="selectedG4">4关</el-checkbox>
                <el-checkbox v-model="selectedG5">5关</el-checkbox>
                <el-checkbox v-model="selectedG6">6关</el-checkbox>
                <span>超过6场只能选择单关或自由过关进行计算！</span>
              </div>
              <div v-if="count == 6 && cpTypeName != '足球比分' && cpTypeName != '足球半全场胜平负'">
                <el-checkbox v-model="selectedG2">2关</el-checkbox>
                <el-checkbox v-model="selectedG3">3关</el-checkbox>
                <el-checkbox v-model="selectedG4">4关</el-checkbox>
                <el-checkbox v-model="selectedG5">5关</el-checkbox>
                <el-checkbox v-model="selectedG6">6关</el-checkbox>
              </div>
              <div v-if="count == 7 && cpTypeName != '足球比分' && cpTypeName != '足球半全场胜平负' && cpTypeName != '足球总进球数'">
                <el-checkbox v-model="selectedG2">2关</el-checkbox>
                <el-checkbox v-model="selectedG3">3关</el-checkbox>
                <el-checkbox v-model="selectedG4">4关</el-checkbox>
                <el-checkbox v-model="selectedG5">5关</el-checkbox>
                <el-checkbox v-model="selectedG6">6关</el-checkbox>
                <el-checkbox v-model="selectedG7">7关</el-checkbox>
              </div>
              <div v-if="count == 8 && cpTypeName != '足球比分' && cpTypeName != '足球半全场胜平负' && cpTypeName != '足球总进球数'">
                <el-checkbox v-model="selectedG2">2关</el-checkbox>
                <el-checkbox v-model="selectedG3">3关</el-checkbox>
                <el-checkbox v-model="selectedG4">4关</el-checkbox>
                <el-checkbox v-model="selectedG5">5关</el-checkbox>
                <el-checkbox v-model="selectedG6">6关</el-checkbox>
                <el-checkbox v-model="selectedG7">7关</el-checkbox>
                <el-checkbox v-model="selectedG8">8关</el-checkbox>
              </div>
            </el-form-item>
          </el-col>
        </div>
      </el-row>

      <el-row>
        <el-col :span="3">
          <el-form-item label="下单完自动刷新">
            <el-checkbox v-model="isRefresh"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备注">
            <el-input placeholder="请输入备注" v-model="remark"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="理论最高奖金:">
            <span><b>{{bonus}}</b></span><!--&nbsp;&nbsp;&nbsp;&nbsp;<span><b>{{bonusTmp}}</b></span>&nbsp;&nbsp;&nbsp;&nbsp;<span><b>{{bonusTmp2}}</b></span>-->
          </el-form-item>
        </el-col>
<!--        <el-col :span="6">
          <el-form-item label="服务id:">
            <el-select v-model="serverId" placeholder="请选择打印服务">
              <el-option v-for="item in selectOptions" :key="item.Id" :label="item.Id" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>-->
        <el-col :span="2">
          <el-button @click="saveRecordMethod">打印</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { generateRandomString, formatCurrentDate, formatDateToYYMMDD } from '../../utils.js'
import CounterInput from '../common/CounterInput.vue'
import axios from 'axios'
export default {
  components: {
    CounterInput // 注册组件
  },
  name: 'Footer',
  computed: {
    type () {
      return this.$store.state.type
    },
    selectBtFiveList () {
      return this.$store.state.selectBtFiveList
    },
    selectBtFourList () {
      return this.$store.state.selectBtFourList
    },
    selectBtThreeList () {
      return this.$store.state.selectBtThreeList
    },
    selectBtTwoList () {
      return this.$store.state.selectBtTwoList
    },
    selectBtOneList () {
      return this.$store.state.selectBtOneList
    },
    selectFtFiveList () {
      return this.$store.state.selectFtFiveList
    },
    selectFtFourList () {
      return this.$store.state.selectFtFourList
    },
    selectFtThreeList () {
      return this.$store.state.selectFtThreeList
    },
    selectFtTwoList () {
      console.log('two:' + this.$store.state.selectFtTwoList)
      return this.$store.state.selectFtTwoList
    },
    selectFtOneList () {
      console.log('one:' + this.$store.state.selectFtOneList)
      return this.$store.state.selectFtOneList
    },
    cpTypeName () {
      return this.$store.state.cpTypeName
    },
    // 使用 Vuex 获取数据
    count () {
      return this.$store.state.count // 场次数量
    },
    dcount () {
      return this.$store.state.dcount // 单关场次数量
    },
    GToggle () {
      return this.$store.state.GToggle // 是否可选单关
    },
    selectedGToggle: {
      get () {
        return this.$store.state.selectedGToggle
      },
      set (v) {
        this.$store.state.selectedGToggle = v
        if (v) {
          if (v) {
            this.selectedMN = null
            this.selectedG2 = false
            this.selectedG3 = false
            this.selectedG4 = false
            this.selectedG5 = false
            this.selectedG6 = false
            this.selectedG7 = false
            this.selectedG8 = false
          }
        }
      }
    },
    ggType: {
      get () {
        return this.$store.state.ggType
      },
      set (v) {
        this.$store.state.ggType = v
        if (this.selectedGToggle) {
          this.selectedGToggle = false
        }
        if (v === 1) {
          this.selectedG2 = true
        } else if (v === 0) {
          if (this.count === 2) {
            this.selectedMN = '2x1'
          } else if (this.count === 3) {
            this.selectedMN = '3x1'
          } else if (this.count === 4) {
            this.selectedMN = '4x1'
          } else if (this.count === 5) {
            this.selectedMN = '5x1'
          } else if (this.count === 6) {
            this.selectedMN = '6x1'
          } else if (this.count === 7) {
            this.selectedMN = '7x1'
          } else if (this.count === 8) {
            this.selectedMN = '8x1'
          }
        }
      }
    },
    selectedMN: {
      get () {
        return this.$store.state.selectedMN
      },
      set (v) {
        this.$store.state.selectedMN = v
        if (v) {
          this.selectedGToggle = false
          this.selectedG2 = false
          this.selectedG3 = false
          this.selectedG4 = false
          this.selectedG5 = false
          this.selectedG6 = false
          this.selectedG7 = false
          this.selectedG8 = false
        }
      }
    },
    selectedG2: {
      get () {
        return this.$store.state.selectedG2
      },
      set (v) {
        this.$store.state.selectedG2 = v
        if (v) {
          this.selectedGToggle = false
          this.selectedMN = null
        }
      }
    },
    selectedG3: {
      get () {
        return this.$store.state.selectedG3
      },
      set (v) {
        this.$store.state.selectedG3 = v
        if (v) {
          this.selectedGToggle = false
          this.selectedMN = null
        }
      }
    },
    selectedG4: {
      get () {
        return this.$store.state.selectedG4
      },
      set (v) {
        this.$store.state.selectedG4 = v
        if (v) {
          this.selectedGToggle = false
          this.selectedMN = null
        }
      }
    },
    selectedG5: {
      get () {
        return this.$store.state.selectedG5
      },
      set (v) {
        this.$store.state.selectedG5 = v
        if (v) {
          this.selectedGToggle = false
          this.selectedMN = null
        }
      }
    },
    selectedG6: {
      get () {
        return this.$store.state.selectedG6
      },
      set (v) {
        this.$store.state.selectedG6 = v
        if (v) {
          this.selectedGToggle = false
          this.selectedMN = null
        }
      }
    },
    selectedG7: {
      get () {
        return this.$store.state.selectedG7
      },
      set (v) {
        this.$store.state.selectedG7 = v
        if (v) {
          this.selectedGToggle = false
          this.selectedMN = null
        }
      }
    },
    selectedG8: {
      get () {
        return this.$store.state.selectedG8
      },
      set (v) {
        this.$store.state.selectedG8 = v
        if (v) {
          this.selectedGToggle = false
          this.selectedMN = null
        }
      }
    }
  },
  created () {
    // this.selectServiceList()
  },
  data () {
    return {
      selectOptions: [],
      selectDateTime: new Date(),
      num: 1, // 份数
      multiple: 1, // 倍数
      playTypes: [],
      monery: 0,
      bonus: 0,
      bonusTmp: 0,
      bonusTmp2: 0,
      serverId: '',
      zcountMap: {},
      remark: '',
      isRefresh: true,
      neirong: '',
      zcount: 0,
      pattern: /\[.*?\]/g,
      match_infos: [],
      hhFlag: false, // 是否是混合
      cyTypeNameTmp: ''
    }
  },
  methods: {
    selectServiceList () {
      axios.get('api/print/list').then((res) => {
        if (res && res.data.code === 200) {
          this.selectOptions = JSON.parse(res.data.result)
        }
      })
    },
    formatNumber (value) {
      // this.bonusTmp2 = value
      // 将输入值转换为浮点数
      let num = parseFloat(value)
      if (isNaN(num)) {
        return value // 如果输入值不是有效数字，直接返回原值
      }
      num = Math.round(num * 100) / 100 // 四舍五入保留两位小数
      // this.bonusTmp = num

      // 提取整数部分和小数部分
      let [integerPart, decimalPart] = num.toString().split('.')
      if (!decimalPart) {
        decimalPart = '00' // 没有小数部分补全为两位
      } else if (decimalPart.length < 2) {
        decimalPart = decimalPart.padEnd(2, '0') // 小数部分不足两位补全为两位
      }

      const firstDecimal = parseInt(decimalPart[0]) // 小数第一位
      const secondDecimal = parseInt(decimalPart[1]) // 小数第二位

      // 如果 multiple 是 10 的倍数
      if (this.multiple % 10 === 0) {
        if (secondDecimal <= 5) {
          decimalPart = firstDecimal + '0' // 保留第一位，第二位为 0
        } else {
          decimalPart = (firstDecimal + 1) + '0' // 第一位进 1，第二位为 0
          if (parseInt(decimalPart) >= 100) {
            integerPart = (parseInt(integerPart) + 1).toString() // 处理进位
            decimalPart = '00'
          }
        }
        // 确保小数部分只可能是 "00" 或 "50"
        if (decimalPart === '00' || decimalPart === '10' || decimalPart === '20' || decimalPart === '30' || decimalPart === '40') {
          decimalPart = '00'
        } else if (decimalPart === '50' || decimalPart === '60' || decimalPart === '70' || decimalPart === '80') {
          decimalPart = '50'
        } else {
          integerPart = (parseInt(integerPart) + 1).toString() // 处理进位
          decimalPart = '00'
        }
      } else {
        // 否则执行标准规则
        if (secondDecimal <= 5) {
          decimalPart = firstDecimal + '0' // 小数部分保留第一位，第二位为0
        } else {
          decimalPart = (firstDecimal + 1) + '0' // 小数部分第一位进1，第二位为0
          if (parseInt(decimalPart) >= 100) {
            integerPart = (parseInt(integerPart) + 1).toString() // 如果小数进位导致进位到整数部分
            decimalPart = '00'
          }
        }
      }

      // 返回结果，确保小数点后只有两位
      return `${integerPart}.${decimalPart}`
    },
    ftFiveMethod () {
      if (this.selectFtFiveList.length > 0) {
        const allSelectTypeSame = this.selectFtFiveList.every(item => item.selectType === this.selectFtFiveList[0].selectType)
        if (!allSelectTypeSame) {
          this.hhFlag = true
        } else {
          this.hhFlag = false
        }
        const foneList = this.selectFtFiveList.filter(v => v.selectType === 'one')
        let isAllOne = false
        if (foneList.length === this.selectFtFiveList.length) {
          isAllOne = true
        }
        // 初始化变量
        let allZero = true
        let allNonZero = true

        if (foneList.length > 0) {
          const capNames = foneList.map(item => item.selectCap)

          // 遍历 capNames 数组，检查每个值
          capNames.forEach(cap => {
            if (cap !== '0' && cap !== '单0') {
              allZero = false // 有非0值
            } else {
              allNonZero = false // 有0值
            }
          })
          if (this.hhFlag === false) {
            if (allZero === false && allNonZero === false) {
              this.hhFlag = true
            } else {
              this.hhFlag = false
              this.cyTypeNameTmp = '足球胜平负'
            }
          }
        }
        let z = 0 // 注数
        this.neirong = ''
        this.match_infos = []
        for (let i = 0; i < this.selectFtFiveList.length; i++) {
          const item = this.selectFtFiveList[i]
          let capName = ''
          let teams
          let matchInfo = {match_scores: '', match_type: '', match_teams: ''}
          let wf = ''
          switch (item.selectType) {
            case 'one':
              const lastChar = item.selectCap[item.selectCap.length - 1]
              if (this.hhFlag === false) {
                if (item.selectCap.includes('+')) {
                  capName = allZero
                    ? ''
                    : allNonZero
                      ? `主队受让${lastChar}球`
                      : `让球胜平负  主队受让${lastChar}球`
                } else if (item.selectCap.includes('-')) {
                  capName = allZero
                    ? ''
                    : allNonZero
                      ? `主队让${lastChar}球`
                      : `让球胜平负  主队让${lastChar}球`
                } else {
                  if (isAllOne) {
                    capName = allZero ? '' : allNonZero ? '' : '胜平负'
                  } else {
                    capName = allZero ? '胜平负' : allNonZero ? '' : '胜平负'
                  }
                }
              } else {
                if (item.selectCap.includes('+')) {
                  capName = `让球胜平负  主队受让${lastChar}球`
                } else if (item.selectCap.includes('-')) {
                  capName = `让球胜平负  主队让${lastChar}球`
                } else {
                  capName = '胜平负'
                }
              }
              teams = item.teamqName.split(' VS ')
              if (this.hhFlag) {
                this.neirong += `第${i + 1}场${item.code.replace(/\s/g, '')} ${capName}\n主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}\n`
                matchInfo.match_type = `第${i + 1}场${item.code.replace(/\s/g, '')} ${capName}`
                matchInfo.match_teams = `主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}`
              } else {
                this.neirong += `第${i + 1}场  ${item.code.replace(/\s/g, '')}  ${capName}\n主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}\n`
                matchInfo.match_type = `第${i + 1}场  ${item.code.replace(/\s/g, '')}  ${capName}`
                matchInfo.match_teams = `主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}`
              }

              if (item.selectOneWinLose.length > 0) {
                this.neirong += item.selectOneWinLose.join('+')
                matchInfo.match_scores += item.selectOneWinLose.join('+')
              }
              this.neirong += '\n'
              z += item.selectOneWinLose.length
              break

            case 'two':
              if (!allSelectTypeSame) {
                wf = '比分'
                this.hhFlag = true
              } else {
                this.hhFlag = false
                this.cyTypeNameTmp = '足球比分'
              }
              teams = item.teamqName.split(' VS ')

              if (this.hhFlag) {
                this.neirong += `第${i + 1}场${item.code.replace(/\s/g, '')} ` + wf + `\n主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}\n`
                matchInfo.match_type = `第${i + 1}场${item.code.replace(/\s/g, '')} ` + wf
                matchInfo.match_teams = `主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}`
              } else {
                this.neirong += `第${i + 1}场  ${item.code.replace(/\s/g, '')}  ` + wf + `\n主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}\n`
                matchInfo.match_type = `第${i + 1}场  ${item.code.replace(/\s/g, '')}  ` + wf
                matchInfo.match_teams = `主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}`
              }

              item.selectTwoWinLose.forEach((selects, k) => {
                const select = selects.split(' ')
                const tmp = select[1]
                this.neirong += k === 0 ? `(${select[0]})@${tmp}元` : `+(${select[0]})@${tmp}元`
                matchInfo.match_scores += k === 0 ? `(${select[0]})@${tmp}元` : `+(${select[0]})@${tmp}元`
              })
              this.neirong += '\n'
              z += item.selectTwoWinLose.length
              break

            case 'three':
              if (!allSelectTypeSame) {
                wf = '总进球数'
                this.hhFlag = true
              } else {
                this.hhFlag = false
                this.cyTypeNameTmp = '足球总进球数'
              }
              teams = item.teamqName.split(' VS ')
              if (this.hhFlag) {
                this.neirong += `第${i + 1}场${item.code.replace(/\s/g, '')} ` + wf + `\n主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}\n`
                matchInfo.match_type = `第${i + 1}场${item.code.replace(/\s/g, '')} ` + wf
                matchInfo.match_teams = `主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}`
              } else {
                this.neirong += `第${i + 1}场  ${item.code.replace(/\s/g, '')}  ` + wf + `\n主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}\n`
                matchInfo.match_type = `第${i + 1}场  ${item.code.replace(/\s/g, '')}  ` + wf
                matchInfo.match_teams = `主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}`
              }
              this.neirong += item.selectThreeWinLose.join('+') + '\n'
              matchInfo.match_scores += item.selectThreeWinLose.join('+')

              z += item.selectThreeWinLose.length
              break

            case 'four':
              if (!allSelectTypeSame) {
                wf = '半全场胜平负'
                this.hhFlag = true
              } else {
                this.hhFlag = false
                this.cyTypeNameTmp = '足球半全场胜平负'
              }
              teams = item.teamqName.split(' VS ')
              if (this.hhFlag) {
                this.neirong += `第${i + 1}场${item.code.replace(/\s/g, '')} ` + wf + `\n主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}\n`
                matchInfo.match_type = `第${i + 1}场${item.code.replace(/\s/g, '')} ` + wf
                matchInfo.match_teams = `主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}`
              } else {
                this.neirong += `第${i + 1}场  ${item.code.replace(/\s/g, '')}  ` + wf + `\n主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}\n`
                matchInfo.match_type = `第${i + 1}场  ${item.code.replace(/\s/g, '')}  ` + wf
                matchInfo.match_teams = `主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}`
              }
              this.neirong += item.selectFourWinLose.join('+') + '\n'
              matchInfo.match_scores += item.selectFourWinLose.join('+')
              z += item.selectFourWinLose.length
              break

            default:
              break
          }
          this.match_infos.push(matchInfo)
        }

        let zcountListStr = ''
        this.zcount = 0

        if (Object.keys(this.zcountMap).length > 0) {
          Object.entries(this.zcountMap).forEach(([key, value]) => {
            zcountListStr += `${key}*${value}注,`
            this.zcount += value
          })
          zcountListStr = zcountListStr.slice(0, -1) // 去掉最后的逗号
        }

        if (this.playTypes.some(v => v.includes('单'))) {
          this.zcount = z
          this.neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n本票最高可能固定奖金:${this.bonus}元\n单倍注数:单场*${this.zcount}注;共${this.zcount}注`
        } else {
          this.neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n本票最高可能固定奖金:${this.bonus}元\n单倍注数:${zcountListStr};共${this.zcount}注`
        }
      }
    },
    ftFourMethod () {
      this.match_infos = []
      let neirong = ''
      let z = 0 // 注数

      if (this.selectFtFourList.length > 0) {
        // Iterate through selectFtFourList
        for (let i = 0; i < this.selectFtFourList.length; i++) {
          let teams = this.selectFtFourList[i].teamqName.split(' VS ')
          let matchInfo = {match_scores: '', match_type: '', match_teams: ''}
          // Build the neirong string for the match
          neirong += `第${i + 1}场  ${this.selectFtFourList[i].code.replace(' ', '')} \n`
          neirong += `主队:${teams[0].replace(this.pattern, '').replace('单', '')} Vs 客队:${teams[1].replace(this.pattern, '')} \n`

          matchInfo.match_type = `第${i + 1}场  ${this.selectFtFourList[i].code.replace(' ', '')}`
          matchInfo.match_teams = `主队:${teams[0].replace(this.pattern, '').replace('单', '')} Vs 客队:${teams[1].replace(this.pattern, '')}`

          // Iterate over the selectWdls array to add selections to neirong
          for (let k = 0; k < this.selectFtFourList[i].selectWdls.length; k++) {
            neirong += k === 0 ? this.selectFtFourList[i].selectWdls[k] : `+${this.selectFtFourList[i].selectWdls[k]}`
            matchInfo.match_scores += k === 0 ? this.selectFtFourList[i].selectWdls[k] : `+${this.selectFtFourList[i].selectWdls[k]}`
          }
          this.match_infos.push(matchInfo)
          neirong += '\n'
          z += this.selectFtFourList[i].selectWdls.length
        }

        // Process the zcountMap if it exists
        let zcountListStr = ''
        this.zcount = 0

        if (Object.keys(this.zcountMap).length > 0) {
          for (let entry in this.zcountMap) {
            zcountListStr += `${entry}*${this.zcountMap[entry]}注,`
            this.zcount += this.zcountMap[entry]
          }
          zcountListStr = zcountListStr.slice(0, -1) // Remove trailing comma
        }

        // If playTypes contains "单", handle the special case
        if (this.selectedGToggle) {
          this.zcount = z
          neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n本票最高可能固定奖金: ${this.bonus}元\n单倍注数:单场*${this.zcount}注;共${this.zcount}注`
        } else {
          neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n本票最高可能固定奖金: ${this.bonus}元\n单倍注数: ${zcountListStr};共${this.zcount}注`
        }
      }
      this.neirong = neirong
    },
    ftThreeMethod () {
      this.match_infos = []
      let neirong = '' // Initialize the content string
      let z = 0 // Initialize the count of selections

      // Loop through the `selectFtThreeList` array
      this.selectFtThreeList.forEach((item, i) => {
        let teams = item.teamqName.split(' VS ')
        let matchInfo = {match_scores: '', match_type: '', match_teams: ''}
        // Concatenate the content based on the teams
        neirong += `第${i + 1}场  ${item.code.replace(' ', '')} \n`
        neirong += `主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')} \n`

        matchInfo.match_type = `第${i + 1}场  ${item.code.replace(' ', '')}`
        matchInfo.match_teams = `主队:${teams[0].replace(this.pattern, '')} Vs 客队:${teams[1].replace(this.pattern, '')}`

        // Add selections to the content
        item.selectWdls.forEach((wdl, k) => {
          neirong += k === 0 ? wdl : `+${wdl}`
          matchInfo.match_scores += k === 0 ? wdl : `+${wdl}`
        })
        neirong += '\n'
        this.match_infos.push(matchInfo)
        // Update the selection count
        z += item.selectWdls.length
      })
      let zcountListStr = ''
      this.zcount = 0

      // Process zcountMap and calculate total count
      if (Object.keys(this.zcountMap).length > 0) {
        for (let [key, value] of Object.entries(this.zcountMap)) {
          zcountListStr += `${key}*${value}注,`
          this.zcount += value
        }
        zcountListStr = zcountListStr.slice(0, -1) // Remove trailing comma
      }

      // Handle bonus and content formatting based on `playTypes`
      if (this.selectedGToggle) {
        this.zcount = z
        neirong += `(选项固定奖金额为每1元投注对应的奖金额) \n`
        neirong += `本票最高可能固定奖金: ${this.bonus}元 \n`
        neirong += `单倍注数: 单场*${this.zcount}注; 共${this.zcount}注`
      } else {
        neirong += `(选项固定奖金额为每1元投注对应的奖金额) \n`
        neirong += `本票最高可能固定奖金: ${this.bonus}元 \n`
        neirong += `单倍注数: ${zcountListStr}; 共${this.zcount}注`
      }

      // Return or assign to a data property as needed
      this.neirong = neirong
    },
    ftTwoMethod () {
      this.match_infos = []
      let z = 0
      let pattern = /\[.*?\]/g // 假设的正则模式
      this.neirong = '' // 清空 neirong

      // 遍历 selectFtTwoList
      this.selectFtTwoList.forEach((item, i) => {
        let teams = item.teamqName.split(' VS ')
        let matchInfo = {match_scores: '', match_type: '', match_teams: ''}
        // 拼接内容
        this.neirong += `第${i + 1}场  ${item.code.replace(' ', '')} \n主队:${teams[0].replace(pattern, '').replace('单', '')} Vs 客队:${teams[1].replace(pattern, '')}\n`
        matchInfo.match_type = `第${i + 1}场  ${item.code.replace(' ', '')}`
        matchInfo.match_teams = `主队:${teams[0].replace(pattern, '')} Vs 客队:${teams[1].replace(pattern, '')}`
        item.selectWdls.forEach((wdls, k) => {
          const wdl = wdls.split(' ')
          let tmp = wdl[1]
          if (k === 0) {
            this.neirong += `(${wdl[0]})@${tmp}元`
            matchInfo.match_scores += `(${wdl[0]})@${tmp}元`
          } else {
            this.neirong += `+(${wdl[0]})@${tmp}元`
            matchInfo.match_scores += `+(${wdl[0]})@${tmp}元`
          }
        })
        this.match_infos.push(matchInfo)
        this.neirong += '\n'
        z += item.selectWdls.length
      })

      // 计算注数
      let zcountListStr = ''
      this.zcount = 0
      if (Object.keys(this.zcountMap).length > 0) {
        Object.entries(this.zcountMap).forEach(([key, value]) => {
          zcountListStr += `${key}*${value}注,`
          this.zcount += value
        })
        zcountListStr = zcountListStr.slice(0, -1) // 去掉最后一个逗号
      }

      // 处理奖金额
      if (this.selectedGToggle) {
        this.zcount = z
        this.neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n本票最高可能固定奖金:${this.bonus}元\n单倍注数:单场*${this.zcount}注;共${this.zcount}注`
      } else {
        this.neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n本票最高可能固定奖金:${this.bonus}元\n单倍注数:${zcountListStr};共${this.zcount}注`
      }
    },
    ftOneMethod () {
      this.match_infos = []
      const pattern = /\[.*?\]/g
      if (this.selectFtOneList.length > 0) {
        const capNames = this.selectFtOneList.map(item => item.selectCap)

        let allZero = true
        let allNonZero = true

        capNames.forEach(cap => {
          if (cap !== '0') {
            allZero = false
          } else {
            allNonZero = false
          }
        })

        let z = 0 // 注数

        this.selectFtOneList.forEach((item, i) => {
          let matchInfo = {match_scores: '', match_type: '', match_teams: ''}
          let capName = ''
          let lastChar = item.selectCap[item.selectCap.length - 1]

          if (item.selectCap.includes('+')) {
            if (allZero) {
              capName = ''
            } else if (allNonZero) {
              capName = `主队受让${lastChar}球`
            } else {
              capName = `让球胜平负  主队受让${lastChar}球`
              this.hhFlag = true
            }
          } else if (item.selectCap.includes('-')) {
            if (allZero) {
              capName = ''
            } else if (allNonZero) {
              capName = `主队让${lastChar}球`
            } else {
              capName = `让球胜平负  主队让${lastChar}球`
              this.hhFlag = true
            }
          } else {
            if (allZero) {
              capName = ''
            } else if (allNonZero) {
              capName = ''
            } else {
              capName = '胜平负'
              this.hhFlag = true
            }
          }

          const teams = item.teamqName.split(' VS ')
          if (this.hhFlag) {
            this.neirong += `第${i + 1}场${item.code.replace(' ', '')} ${capName}\n` +
              `主队:${teams[0].replace(pattern, '')} Vs 客队:${teams[1].replace(pattern, '')}\n`
            matchInfo.match_type = `第${i + 1}场${item.code.replace(' ', '')} ${capName}`
            matchInfo.match_teams = `主队:${teams[0].replace(pattern, '')} Vs 客队:${teams[1].replace(pattern, '')}`
            if (item.selectWinDrawLoses.length > 0) {
              item.selectWinDrawLoses.forEach((value, k) => {
                this.neirong += (k === 0 ? value : `+${value}`)
                matchInfo.match_scores += (k === 0 ? value : `+${value}`)
              })
            }
          } else {
            this.neirong += `第${i + 1}场  ${item.code.replace(' ', '')}  ${capName}\n` +
              `主队:${teams[0].replace(pattern, '')} Vs 客队:${teams[1].replace(pattern, '')}\n`
            matchInfo.match_type = `第${i + 1}场  ${item.code.replace(' ', '')}  ${capName}`
            matchInfo.match_teams = `主队:${teams[0].replace(pattern, '')} Vs 客队:${teams[1].replace(pattern, '')}`
            if (item.selectWinDrawLoses.length > 0) {
              item.selectWinDrawLoses.forEach((value, k) => {
                this.neirong += (k === 0 ? value : `+${value}`)
                matchInfo.match_scores += (k === 0 ? value : `+${value}`)
              })
            }
          }

          /* this.neirong += `第${i + 1}场  ${item.code.replace(' ', '')} ${capName}\n` +
            `主队:${teams[0].replace(pattern, '')} Vs 客队:${teams[1].replace(pattern, '')}\n`
          matchInfo.match_type = `第${i + 1}场  ${item.code.replace(' ', '')} ${capName}`
          matchInfo.match_teams = `主队:${teams[0].replace(pattern, '')} Vs 客队:${teams[1].replace(pattern, '')}`
          if (item.selectWinDrawLoses.length > 0) {
            item.selectWinDrawLoses.forEach((value, k) => {
              this.neirong += (k === 0 ? value : `+${value}`)
              matchInfo.match_scores += (k === 0 ? value : `+${value}`)
            })
          } */
          this.match_infos.push(matchInfo)
          this.neirong += '\n'
          z += item.selectWinDrawLoses.length
        })

        if (this.selectedGToggle) {
          this.zcount = z
          this.neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n本票最高可能固定奖金:${this.bonus}元\n单倍注数:单场*${this.zcount}注;共${this.zcount}注`
        } else {
          let zcountListStr = ''
          this.zcount = 0

          if (Object.keys(this.zcountMap).length > 0) {
            for (const [key, value] of Object.entries(this.zcountMap)) {
              zcountListStr += `${key}*${value}注,`
              this.zcount += value
            }

            zcountListStr = zcountListStr.slice(0, -1) // 去掉最后一个逗号
          }

          this.neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n本票最高可能固定奖金:${this.bonus}元\n单倍注数:${zcountListStr};共${this.zcount}注`
        }
      }
    },

    btFiveMethod () {
      if (this.selectBtFiveList.length > 0) {
        const allSelectTypeSame = this.selectBtFiveList.every(item => item.selectType === this.selectBtFiveList[0].selectType)
        if (!allSelectTypeSame) {
          this.hhFlag = true
        } else {
          this.hhFlag = false
        }
        let wf = ''
        let neirong = ''
        // let z = 0 // 注数
        this.match_infos = []
        for (let i = 0; i < this.selectBtFiveList.length; i++) {
          let matchInfo = {match_scores: '', match_type: '', match_teams: ''}
          const item = this.selectBtFiveList[i]
          const teams = item.teamqName.split(' VS ')

          switch (item.selectType) {
            case 'one':
              if (!allSelectTypeSame) {
                wf = '胜负'
                this.hhFlag = true
              } else {
                wf = ''
                this.hhFlag = false
                this.cyTypeNameTmp = '篮球让分胜负'
              }
              if (this.hhFlag) {
                neirong += `第${i + 1}场${item.code.replace(/ /g, '')} ` + wf +
                  `\n客队:${teams[0]} Vs 主队:${teams[1]}\n`

                matchInfo.match_type = `第${i + 1}场${item.code.replace(/ /g, '')} ` + wf
                matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`
              } else {
                neirong += `第${i + 1}场  ${item.code.replace(/ /g, '')}  ` + wf +
                  `\n客队:${teams[0]} Vs 主队:${teams[1]}\n`

                matchInfo.match_type = `第${i + 1}场  ${item.code.replace(/ /g, '')}  ` + wf
                matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`
              }

              if (item.selectOneWinLose.length > 0) {
                neirong += item.selectOneWinLose.join('+') + '\n'
                matchInfo.match_scores += item.selectOneWinLose.join('+')
                // z += item.selectOneWinLose.length
              }
              break
            case 'two':

              if (!allSelectTypeSame) {
                wf = '让分胜负'
                this.hhFlag = true
              } else {
                this.hhFlag = false
                this.cyTypeNameTmp = '篮球让分胜负'
              }
              let ps = ''
              //alert(this.selectBtFiveList[i].rf)
              if (this.selectBtFiveList[i].rf.includes('-')) {
                ps = '主队让' + this.selectBtFiveList[i].rf.replace('-', '') + '分'
              } else if (this.selectBtFiveList[i].rf.includes('+')) {
                ps = '主队受让' + this.selectBtFiveList[i].rf.replace('+', '') + '分'
              }

              if (this.hhFlag) {
                neirong += `第${i + 1}场${item.code.replace(/ /g, '')} 让分胜负  ` + ps + `\n` +
                  `客队:${teams[0]} Vs 主队:${teams[1]}\n`

                matchInfo.match_type = `第${i + 1}场${item.code.replace(/ /g, '')} 让分胜负  ` + ps
                matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`
              } else {
                neirong += `第${i + 1}场  ${item.code.replace(/ /g, '')}  ` + ps + `\n` +
                  `客队:${teams[0]} Vs 主队:${teams[1]}\n`

                matchInfo.match_type = `第${i + 1}场  ${item.code.replace(/ /g, '')}  ` + ps
                matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`
              }

              if (item.selectTwoWinLose.length > 0) {
                neirong += item.selectTwoWinLose.join('+') + '\n'
                matchInfo.match_scores += item.selectTwoWinLose.join('+')
                // z += item.selectTwoWinLose.length
              }
              //alert(neirong)
              break
            case 'three':
              if (!allSelectTypeSame) {
                wf = '胜分差'
                this.hhFlag = true
              } else {
                wf = ''
                this.hhFlag = false
                this.cyTypeNameTmp = '篮球胜分差'
              }

              if (this.hhFlag) {
                neirong += `第${i + 1}场${item.code.replace(/ /g, '')} ` + wf +
                  `\n客队:${teams[0]} Vs 主队:${teams[1]}\n`

                matchInfo.match_type = `第${i + 1}场${item.code.replace(/ /g, '')} ` + wf
                matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`
              } else {
                neirong += `第${i + 1}场  ${item.code.replace(/ /g, '')}  ` + wf +
                  `\n客队:${teams[0]} Vs 主队:${teams[1]}\n`

                matchInfo.match_type = `第${i + 1}场  ${item.code.replace(/ /g, '')}  ` + wf
                matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`
              }
              if (item.selectThreeWinLose.length > 0) {
                neirong += item.selectThreeWinLose.join('+') + '\n'
                matchInfo.match_scores += item.selectThreeWinLose.join('+')
                // z += item.selectThreeWinLose.length
              }
              break
            case 'four':
              if (!allSelectTypeSame) {
                this.hhFlag = true
              } else {
                this.hhFlag = false
                this.cyTypeNameTmp = '篮球大小分'
              }

              if (this.hhFlag) {
                neirong += `第${i + 1}场${item.code.replace(/ /g, '')} 大小分  预设总分:` + this.selectBtFiveList[i].zf + `\n` +
                  `客队:${teams[0]} Vs 主队:${teams[1]}\n`

                matchInfo.match_type = `第${i + 1}场${item.code.replace(/ /g, '')} 大小分  预设总分:` + this.selectBtFiveList[i].zf
                matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`
              } else {
                neirong += `第${i + 1}场  ${item.code.replace(/ /g, '')}  预设总分:` + this.selectBtFiveList[i].zf + `\n` +
                  `客队:${teams[0]} Vs 主队:${teams[1]}\n`

                matchInfo.match_type = `第${i + 1}场  ${item.code.replace(/ /g, '')}  预设总分:` + this.selectBtFiveList[i].zf
                matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`
              }
              if (item.selectFourWinLose.length > 0) {
                neirong += item.selectFourWinLose.join('+') + '\n'
                matchInfo.match_scores += item.selectFourWinLose.join('+')
                // z += item.selectFourWinLose.length
              }
              break
            default:
              break
          }
          this.match_infos.push(matchInfo)
        }
        //alert(this.match_infos)
        let zcountListStr = ''
        this.zcount = 0

        if (Object.keys(this.zcountMap).length > 0) {
          for (const [key, value] of Object.entries(this.zcountMap)) {
            zcountListStr += `${key}*${value}注,`
            this.zcount += value
          }
          zcountListStr = zcountListStr.slice(0, -1)
        }

        neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n` +
          `本票最高可能固定奖金: ${this.bonus}元\n` +
          `单倍注数: ${zcountListStr}; 共${this.zcount}注`

        this.neirong = neirong // 将结果存入响应式属性
      }
    },
    btFourMethod () {
      if (this.selectBtFourList.length > 0) {
        let neirong = ''
        let z = 0 // 注数
        this.match_infos = []
        for (let i = 0; i < this.selectBtFourList.length; i++) {
          let matchInfo = {match_scores: '', match_type: '', match_teams: ''}
          const teams = this.selectBtFourList[i].teamqName.split(' VS ')

          neirong += `第${i + 1}场  ${this.selectBtFourList[i].code.replace(/ /g, '')}  预设总分:` + this.selectBtFourList[i].zf + `\n` +
            `客队:${teams[0]} Vs 主队:${teams[1]}\n`

          matchInfo.match_type = `第${i + 1}场  ${this.selectBtFourList[i].code.replace(/ /g, '')}  预设总分:` + this.selectBtFourList[i].zf
          matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`

          const winLose = this.selectBtFourList[i].selectWinLose
          if (winLose.length > 0) {
            neirong += winLose.join('+') + '\n'
            matchInfo.match_scores += winLose.join('+')
          }
          this.match_infos.push(matchInfo)
          z += winLose.length
        }

        let zcountListStr = ''
        this.zcount = 0

        if (Object.keys(this.zcountMap).length > 0) {
          for (const [key, value] of Object.entries(this.zcountMap)) {
            zcountListStr += `${key}*${value}注,`
            this.zcount += value
          }
          zcountListStr = zcountListStr.slice(0, -1)
        }

        // 检查玩法类型
        if (this.selectedGToggle) {
          this.zcount = z
          neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n` +
            `本票最高可能固定奖金: ${this.bonus}元\n` +
            `单倍注数: 单场*${this.zcount}注; 共${this.zcount}注`
        } else {
          neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n` +
            `本票最高可能固定奖金: ${this.bonus}元\n` +
            `单倍注数: ${zcountListStr}; 共${this.zcount}注`
        }

        // 输出结果
        this.neirong = neirong

        /* neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n` +
          `本票最高可能固定奖金: ${this.bonus}元\n` +
          `单倍注数: ${zcountListStr}; 共${this.zcount}注`

        this.neirong = neirong */
      }
    },
    btThreeMethod () {
      if (this.selectBtThreeList.length > 0) {
        let neirong = ''
        let z = 0 // 注数
        this.match_infos = []
        for (let i = 0; i < this.selectBtThreeList.length; i++) {
          let matchInfo = {match_scores: '', match_type: '', match_teams: ''}
          const teams = this.selectBtThreeList[i].teamqName.split(' VS ')

          neirong += `第${i + 1}场  ${this.selectBtThreeList[i].code.replace(/ /g, '')}\n` +
            `客队:${teams[0]} Vs 主队:${teams[1]}\n`

          matchInfo.match_type = `第${i + 1}场  ${this.selectBtThreeList[i].code.replace(/ /g, '')}`
          matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`

          const winLose = this.selectBtThreeList[i].selectWinLose
          if (winLose.length > 0) {
            neirong += winLose.join('+') + '\n'
            matchInfo.match_scores += winLose.join('+')
          }
          this.match_infos.push(matchInfo)
          z += winLose.length
        }

        let zcountListStr = ''
        this.zcount = 0

        if (Object.keys(this.zcountMap).length > 0) {
          for (const [key, value] of Object.entries(this.zcountMap)) {
            zcountListStr += `${key}*${value}注,`
            this.zcount += value
          }
          zcountListStr = zcountListStr.slice(0, -1) // 去掉最后的逗号
        }

        // 检查玩法类型
        if (this.selectedGToggle) {
          this.zcount = z
          neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n` +
            `本票最高可能固定奖金: ${this.bonus}元\n` +
            `单倍注数: 单场*${this.zcount}注; 共${this.zcount}注`
        } else {
          neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n` +
            `本票最高可能固定奖金: ${this.bonus}元\n` +
            `单倍注数: ${zcountListStr}; 共${this.zcount}注`
        }

        // 输出结果
        this.neirong = neirong
      }
    },
    btTwoMethod () {
      if (this.selectBtTwoList.length > 0) {
        let neirong = ''
        let z = 0 // 注数
        // const pattern = /[^\w\s]/g // 示例正则表达式，可根据实际需求调整
        this.match_infos = []
        for (let i = 0; i < this.selectBtTwoList.length; i++) {
          let ps = ''
          if (this.selectBtTwoList[i].rf.includes('-')) {
            ps = '主队让' + this.selectBtTwoList[i].rf.replace('-', '') + '分'
          } else if (this.selectBtTwoList[i].rf.includes('+')) {
            ps = '主队受让' + this.selectBtTwoList[i].rf.replace('+', '') + '分'
          }

          let matchInfo = {match_scores: '', match_type: '', match_teams: ''}
          const teams = this.selectBtTwoList[i].teamqName.split(' VS ')

          teams[1] = teams[1].replace(/\(.*?\)/, '').trim()
          neirong += `第${i + 1}场  ${this.selectBtTwoList[i].code.replace(/ /g, '')}  ` + ps + `\n` +
            `客队:${teams[0]} Vs 主队:${teams[1]}\n`

          matchInfo.match_type = `第${i + 1}场  ${this.selectBtTwoList[i].code.replace(/ /g, '')}  ` + ps
          matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`

          // neirong += `第${i + 1}场  ${this.selectBtTwoList[i].code.replace(/ /g, '')}\n` +
          //  `主队: ${teams[0].replace(pattern, '')} Vs 客队: ${teams[1].replace(pattern, '')}\n`

          const winLose = this.selectBtTwoList[i].selectWinLose
          if (winLose.length > 0) {
            neirong += winLose.join('+') + '\n'
            matchInfo.match_scores += winLose.join('+')
          }
          this.match_infos.push(matchInfo)
          z += winLose.length
        }

        let zcountListStr = ''
        this.zcount = 0

        if (Object.keys(this.zcountMap).length > 0) {
          for (const [key, value] of Object.entries(this.zcountMap)) {
            zcountListStr += `${key}*${value}注,`
            this.zcount += value
          }
          zcountListStr = zcountListStr.slice(0, -1) // 去掉末尾逗号
        }

        // 计算最高奖金和注数
        // neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n` +
        //   `本票最高可能固定奖金: ${this.bonus}元\n` +
        //   `单倍注数: ${zcountListStr}; 共${this.zcount}注`

        // 检查玩法类型
        if (this.selectedGToggle) {
          this.zcount = z
          neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n` +
            `本票最高可能固定奖金: ${this.bonus}元\n` +
            `单倍注数: 单场*${this.zcount}注; 共${this.zcount}注`
        } else {
          neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n` +
            `本票最高可能固定奖金: ${this.bonus}元\n` +
            `单倍注数: ${zcountListStr}; 共${this.zcount}注`
        }

        this.neirong = neirong
      }
    },
    btOneMethod () {
      if (this.selectBtOneList.length > 0) {
        let neirong = ''
        let z = 0 // 注数
        this.match_infos = []
        for (let i = 0; i < this.selectBtOneList.length; i++) {
          let matchInfo = {match_scores: '', match_type: '', match_teams: ''}
          const teams = this.selectBtOneList[i].teamqName.split(' VS ')
          neirong += `第${i + 1}场  ${this.selectBtOneList[i].code.replace(/ /g, '')} \n` +
            `客队:${teams[0]} Vs 主队:${teams[1]} \n`

          matchInfo.match_type = `第${i + 1}场  ${this.selectBtOneList[i].code.replace(/ /g, '')}`
          matchInfo.match_teams = `客队:${teams[0]} Vs 主队:${teams[1]}`

          const winLose = this.selectBtOneList[i].selectWinLose
          if (winLose.length > 0) {
            neirong += winLose.join('+') + '\n'
            matchInfo.match_scores += winLose.join('+')
          }
          this.match_infos.push(matchInfo)
          z += winLose.length
        }

        let zcountListStr = ''
        this.zcount = 0

        if (Object.keys(this.zcountMap).length > 0) {
          for (const [key, value] of Object.entries(this.zcountMap)) {
            zcountListStr += `${key}*${value}注,`
            this.zcount += value
          }
          zcountListStr = zcountListStr.slice(0, -1) // 去掉末尾逗号
        }

        if (this.selectedGToggle) {
          this.zcount = z
          neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n` +
            `本票最高可能固定奖金: ${this.bonus}元\n` +
            `单倍注数:单场*${this.zcount}注;共${this.zcount}注`
        } else {
          neirong += `(选项固定奖金额为每1元投注对应的奖金额)\n` +
            `本票最高可能固定奖金: ${this.bonus}元\n` +
            `单倍注数:${zcountListStr};共${this.zcount}注`
        }
        this.neirong = neirong
      }
    },
    // 报表初始化处理
    ReportInitialize () {
      switch (this.cpTypeName) {
        case '足球胜平负':
          this.ftOneMethod()
          break
        case '足球比分':
          this.ftTwoMethod()
          break
        case '足球总进球数':
          this.ftThreeMethod()
          break
        case '足球半全场胜平负':
          this.ftFourMethod()
          break
        case '足球混合过关':
          this.ftFiveMethod()
          break
        case '篮球胜负':
          this.btOneMethod()
          break
        case '篮球让分胜负':
          this.btTwoMethod()
          break
        case '篮球胜分差':
          this.btThreeMethod()
          break
        case '篮球大小分':
          this.btFourMethod()
          break
        case '篮球混合过关':
          this.btFiveMethod()
          break
        default:break
      }
    },

    saveRecordMethod () {
      this.neirong = ''
      this.ReportInitialize()
      let number = ''
      if (this.cpTypeName.includes('足')) {
        number = '第' + formatDateToYYMMDD(this.selectDateTime) + '1期'
      } else if (this.cpTypeName.includes('篮')) {
        number = '第' + formatDateToYYMMDD(this.selectDateTime) + '2期'
      }
      const record = {
        dcount: this.dcount,
        count: this.count,
        type: this.type,
        ggType: this.ggType === 0 ? 'M串N' : '自由过关',
        monery: this.monery,
        cpTypeName: this.hhFlag ? this.type.replace('彩', '球') + '混合过关' : this.cyTypeNameTmp === '' ? this.cpTypeName : this.cyTypeNameTmp,
        multiple: this.multiple,
        remark: this.remark,
        bonus: this.bonus,
        bonusTmp: this.bonusTmp,
        playTypes: this.playTypes.join(','),
        zcount: 0,
        zcountMap: this.zcountMap,
        recordInfoList: [],
        isHis: 1,
        price: (this.monery * 0.21).toFixed(2),
        randomString: generateRandomString(),
        zhanhao: '07-210100-101',
        selectDateTime: formatCurrentDate(this.selectDateTime),
        number: number,
        neirong: this.neirong,
        num: this.num,
        ppType: 0,
        match_infos: this.match_infos,
        isApp: false
      }
      // 处理 playTypes 和 zcount
      if (this.selectedGToggle) {
        record.zcount = this.zcount
        record.zcountMap = ''
      } else {
        let zcountListStr = ''
        for (const [key, value] of Object.entries(this.zcountMap)) {
          zcountListStr += `${key}*${value}注,`
          record.zcount += value
        }
        record.zcountMap = zcountListStr.slice(0, -1)
      }
      // 处理记录信息列表
      if (this.type === '足彩') {
        switch (this.cpTypeName) {
          case '足球胜平负':
            this.selectFtOneList.forEach(ft => {
              record.recordInfoList.push({
                cpTypeName: this.cpTypeName,
                cpsInfo: `${ft.selectCap} ${ft.selectWinDrawLoses.join(',')}`,
                ftBtId: ft.id,
                code: ft.code,
                start: ft.start,
                eventProject: ft.eventProject,
                team: ft.team,
                teamqName: ft.teamqName
              })
            })
            break
          case '足球比分':
            this.selectFtTwoList.forEach(ft => {
              record.recordInfoList.push({
                cpTypeName: this.cpTypeName,
                cpsInfo: ft.selectWdls.join(','),
                ftBtId: ft.id,
                code: ft.code,
                start: ft.start,
                eventProject: ft.eventProject,
                team: ft.team,
                teamqName: ft.teamqName
              })
            })
            break
          case '足球总进球数':
            this.selectFtThreeList.forEach(ft => {
              record.recordInfoList.push({
                cpTypeName: this.cpTypeName,
                cpsInfo: ft.selectWdls.join(','),
                ftBtId: ft.id,
                code: ft.code,
                start: ft.start,
                eventProject: ft.eventProject,
                team: ft.team,
                teamqName: ft.teamqName
              })
            })
            break
          case '足球半全场胜平负':
            this.selectFtFourList.forEach(ft => {
              record.recordInfoList.push({
                cpTypeName: this.cpTypeName,
                cpsInfo: ft.selectWdls.join(','),
                ftBtId: ft.id,
                code: ft.code,
                start: ft.start,
                eventProject: ft.eventProject,
                team: ft.team,
                teamqName: ft.teamqName
              })
            })
            break
          case '足球混合过关':
            this.selectFtFiveList.forEach(ft => {
              const info = {
                cpTypeName: this.cpTypeName,
                cpsInfo: '',
                ftBtId: ft.id,
                code: ft.code,
                start: ft.start,
                eventProject: ft.eventProject,
                team: ft.team,
                teamqName: ft.teamqName
              }
              if (ft.selectType === 'one') {
                info.cpsInfo = `${ft.selectCap} ${ft.selectOneWinLose.join(',')}`
                info.cpTypeName += '-足球胜平负'
              }
              if (ft.selectType === 'two') {
                info.cpsInfo = ft.selectTwoWinLose.join(',')
                info.cpTypeName += '-足球比分'
              }
              if (ft.selectType === 'three') {
                info.cpsInfo = ft.selectThreeWinLose.join(',')
                info.cpTypeName += '-足球总进球数'
              }
              if (ft.selectType === 'four') {
                info.cpsInfo = ft.selectFourWinLose.join(',')
                info.cpTypeName += '-足球半全场胜平负'
              }
              record.recordInfoList.push(info)
            })
            break
        }
      } else if (this.type === '篮彩') {
        switch (this.cpTypeName) {
          case '篮球胜负':
            this.selectBtOneList.forEach(bt => {
              const recordInfo = {
                cpTypeName: this.cpTypeName,
                cpsInfo: bt.selectWinLose.join(','),
                ftBtId: bt.id,
                code: bt.code,
                start: bt.start,
                eventProject: bt.eventProject,
                team: bt.team,
                teamqName: bt.teamqName
              }
              record.recordInfoList.push(recordInfo)
            })
            break
          case '篮球让分胜负':
            this.selectBtTwoList.forEach(bt => {
              const recordInfo = {
                cpTypeName: this.cpTypeName,
                cpsInfo: bt.selectWinLose.join(','),
                ftBtId: bt.id,
                code: bt.code,
                start: bt.start,
                eventProject: bt.eventProject,
                team: bt.team,
                teamqName: bt.teamqName
              }
              record.recordInfoList.push(recordInfo)
            })
            break
          case '篮球胜分差':
            this.selectBtThreeList.forEach(bt => {
              const recordInfo = {
                cpTypeName: this.cpTypeName,
                cpsInfo: bt.selectWinLose.join(','),
                ftBtId: bt.id,
                code: bt.code,
                start: bt.start,
                eventProject: bt.eventProject,
                team: bt.team,
                teamqName: bt.teamqName
              }
              record.recordInfoList.push(recordInfo)
            })
            break
          case '篮球大小分':
            this.selectBtFourList.forEach(bt => {
              const recordInfo = {
                cpTypeName: this.cpTypeName,
                cpsInfo: bt.selectWinLose.join(','),
                ftBtId: bt.id,
                code: bt.code,
                start: bt.start,
                eventProject: bt.eventProject,
                team: bt.team,
                teamqName: bt.teamqName
              }
              record.recordInfoList.push(recordInfo)
            })
            break
          case '篮球混合过关':
            this.selectBtFiveList.forEach(bt => {
              const recordInfo = {
                cpTypeName: this.cpTypeName,
                code: bt.code,
                start: bt.start,
                eventProject: bt.eventProject,
                team: bt.team,
                teamqName: bt.teamqName
              }

              if (bt.selectType === 'one') {
                recordInfo.cpsInfo = bt.selectOneWinLose.join(',')
                recordInfo.cpTypeName += '-篮球胜负'
              }
              if (bt.selectType === 'two') {
                recordInfo.cpsInfo = bt.selectTwoWinLose.join(',')
                recordInfo.cpTypeName += '-篮球让分胜负'
              }
              if (bt.selectType === 'three') {
                recordInfo.cpsInfo = bt.selectThreeWinLose.join(',')
                recordInfo.cpTypeName += '-篮球胜分差'
              }
              if (bt.selectType === 'four') {
                recordInfo.cpsInfo = bt.selectFourWinLose.join(',')
                recordInfo.cpTypeName += '-篮球大小分'
              }

              recordInfo.ftBtId = bt.id
              record.recordInfoList.push(recordInfo)
            })
            break
          default:
            break
        }
      }
      record.ppType = this.GetPType()
      console.log(record)
      if (record.monery === 0) {
        this.$message.warning('请完成投注！')
        return
      }
      //alert(JSON.stringify(record))
      this.printSub(record)
      axios.post('api/record/save', record).then((res) => {
        if (res && res.data.code === 200) {
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          if (this.isRefresh) {
            // location.reload()
            this.$store.dispatch('triggerRefresh', true)
          }
        }
      })
      this.hhFlag = false
      this.cyTypeNameTmp = ''
      this.multiple = 1
      this.$refs.counter.reset()
    },

    // 生成四个数字组成的字符串
    generateRandomString () {
      let result = ''
      for (let i = 0; i < 4; i++) {
        result += Math.floor(Math.random() * 10) // 生成0-9之间的随机数字
      }
      return result
    },
    printSub (record) {
      let playType = ''
      if (this.selectedGToggle) {
        playType = record.dcount + '场-单场固定'
      } else {
        if (this.ggType === 0) {
          playType = '过关方式 ' + record.playTypes
        } else if (this.ggType === 1) {
          playType = record.count + '场-' + record.playTypes.replaceAll('关', '') + '关'
        }
      }
      let betNum = ''
      if (this.selectedGToggle) {
        betNum = '单倍注数:单场*' + record.zcount + '注;共' + record.zcount + '注'
      } else {
        betNum = '单倍注数:' + record.zcountMap + ';共' + record.zcount + '注'
      }
      let bonus = parseFloat(record.bonus).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
      let bonusTmp = parseFloat(record.bonusTmp).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })

      let price = ''
      if (record.multiple > 50) {
        price = (100 * record.zcount * 0.21).toFixed(2)
      } else {
        price = (record.monery * 0.21).toFixed(2)
      }

      let json = {
        'type': record.ppType,
        // 'id': this.serverId, // this.generateRandomString(),
        'account': JSON.parse(this.$store.state.sysUserInfo).account,
        'header': {
          'match_period': record.number.replace('第', '').replace('期', ''), // '2411221',
          'match_type': '竞彩' + record.cpTypeName, // '竞彩足球混合过关',
          'match_random': record.randomString + '' // '069764970460227573099423 08244503 BT8PD4GP'
        },
        'body': {
          'pass_type': playType, // '过关方式 ' + record.playTypes, // '过关方式 4x1',
          'multiple': record.multiple > 50 ? 50 + '' : record.multiple + '',
          // 'multiple': record.multiple + '', // '1',
          'total': record.monery > 100 * record.zcount ? 100 * record.zcount + '' : record.monery + '', // '60',
          'match_infos': record.match_infos,
          /* 'match_infos': [
            {
              'match_type': '第1场周五002 比分',
              'match_teams': '主队:纽卡斯尔喷气机 Vs 客队:中央海岸水手',
              'match_scores': '(1:0) 11.00元+(2:0) 16.00元+(2:1) 9.500元+(1:1) 7.250元+(2:2) 12.50元+(3:3) 45.00元'
            },
            {
              'match_type': '第2场周五003 胜平负',
              'match_teams': '主队:明斯特普鲁士 Vs 客队:科隆',
              'match_scores': '平 3.950元'
            },
            {
              'match_type': '第3场周五004 比分',
              'match_teams': '主队:帕德博恩 Vs 客队:纽伦堡',
              'match_scores': '(2:0) 10.00元+(2:1) 7.000元+(3:1) 12.00元+(3:2) 20.00元+(3:3) 45.00元'
            },
            {
              'match_type': '第4场周五005 让球胜平负  主队让1球',
              'match_teams': '主队:摩纳哥 Vs 客队:布雷斯特',
              'match_scores': '平 3.550元'
            }
          ], */
          'max_winnings': this.multiple > 50 ? bonusTmp : bonus, // '56,791.12',
          'bet_num': betNum // '单倍注数:' + record.zcountMap + ';共' + record.zcount + '注' // '单倍注数:4x1*30注;共30注'

        },
        'footer': {
          'adds': '感谢您为公益事业贡献 ' + price + '元', // record.price
          'time': record.selectDateTime.substring(2) // '24/11/22 14:59:36'
        }
      }
      // alert(JSON.stringify(record))
      // alert(JSON.stringify(json))
      axios.post('api/print/normal', json).then((res) => {
        if (res && res.data.code === 1) {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
        }
      })
    },
    // 判断长短票类型
    GetPType () {
      if (this.cpTypeName === '足球比分') {
        if (this.count === 1) {
          let fl = 1
          this.selectFtTwoList[0].selectWdls.forEach(v => {
            let flag = v.split(' ')[0]
            if (flag === '胜其它' || flag === '平其它' || flag === '负其它') {
              if (this.selectFtTwoList[0].selectWdls.length >= 3) {
                fl = 0
              } else {
                fl = 1
              }
            }
          })
          if (fl === 0) {
            return 0
          }
          return (this.selectFtTwoList[0].selectWdls.length > 3) ? 0 : 1
        } else {
          return 0
        }
      } else if (this.cpTypeName === '足球总进球数') {
        if (this.count === 1) {
          return (this.selectFtThreeList[0].selectWdls.length > 3) ? 0 : 1
        } else {
          return 0
        }
      } else if (this.cpTypeName === '足球半全场胜平负') {
        if (this.count === 1) {
          return (this.selectFtFourList[0].selectWdls.length > 3) ? 0 : 1
        } else {
          return 0
        }
      } else if (this.cpTypeName === '篮球胜分差') {
        if (this.count === 1) {
          return (this.selectBtThreeList[0].selectWinLose.length >= 3) ? 0 : 1
        } else {
          return 0
        }
      } else {
        if (this.count === 1) {
          return 1
        } else {
          return 0
        }
      }
    },
    // 向 zcountMap 中添加或更新键值对
    AddToMap (key, value) {
      // 检查键是否已经存在
      if (!this.zcountMap.hasOwnProperty(key)) {
        // 键不存在，则添加
        this.$set(this.zcountMap, key, value)
      } else {
        // 键已存在，更新值
        this.$set(this.zcountMap, key, value)
      }
    },
    updatePlayTypes () {
      this.playTypes = []
      if (this.selectedGToggle) {
        this.playTypes.push('单关')
      }
      if (this.selectedMN !== null) {
        this.playTypes.push(this.selectedMN)
      }
      if (this.selectedG2) {
        this.playTypes.push('2关')
      }
      if (this.selectedG3) {
        this.playTypes.push('3关')
      }
      if (this.selectedG4) {
        this.playTypes.push('4关')
      }
      if (this.selectedG5) {
        this.playTypes.push('5关')
      }
      if (this.selectedG6) {
        this.playTypes.push('6关')
      }
      if (this.selectedG7) {
        this.playTypes.push('7关')
      }
      if (this.selectedG8) {
        this.playTypes.push('8关')
      }
      this.GetNeedMonery()
    },
    // 计算投注金额
    GetNeedMonery () {
      this.zcountMap = {}
      this.monery = 0
      this.bonus = 0
      this.bonusTmp = 0
      // 单关玩法
      if (this.selectedGToggle) {
        this.Djs()
      } else if (this.selectedMN) {
        this.MNjs()
      } else {
        this.Gjs()
      }
      if (this.type === '足彩') {
        /* this.bonus = this.formatNumber(this.bonus)
        this.bonusTmp = this.formatNumber(this.bonusTmp) */
        this.bonus = parseFloat(this.bonus).toFixed(2)
        this.bonusTmp = parseFloat(this.bonusTmp).toFixed(2)
      } if (this.type === '篮彩') {
        this.bonus = parseFloat(this.bonus).toFixed(2)
        this.bonusTmp = parseFloat(this.bonusTmp).toFixed(2)
      }
    },
    Gjs () {
      let max = 0
      for (let k = 0; k < this.playTypes.length; k++) {
        let size = 0
        let result = 0
        let ints = this.getResIns()

        switch (this.playTypes[k]) {
          case '2关':
            size = this.GetValidCombinations(ints, 2)
            this.monery += this.multiple * size * 2

            result = this.GetValidCombinationsSum(ints, 2) // 获取所有有效组合的乘积和
            // this.bonus += this.multiple * result * 2
            this.bonusJS(result)
            max += this.multiple * 200000 * size
            /* if (this.bonus > max) {
              this.bonus = max
            } */
            this.AddToMap('2x1', size)
            break
          case '3关':
            size = this.GetValidCombinations(ints, 3)
            this.monery += this.multiple * size * 2

            result = this.GetValidCombinationsSum(ints, 3) // 获取所有有效组合的乘积和
            // this.bonus += this.multiple * result * 2
            this.bonusJS(result)
            max += this.multiple * 200000 * size
            /* if (this.bonus > max) {
              this.bonus = max
            } */
            this.AddToMap('3x1', size)
            break
          case '4关':
            size = this.GetValidCombinations(ints, 4)
            this.monery += this.multiple * size * 2

            result = this.GetValidCombinationsSum(ints, 4) // 获取所有有效组合的乘积和
            // this.bonus += this.multiple * result * 2
            this.bonusJS(result)

            max += this.multiple * 500000 * size
            /* if (this.bonus > max) {
              this.bonus = max
            } */

            this.AddToMap('4x1', size)
            break
          case '5关':
            size = this.GetValidCombinations(ints, 5)
            this.monery += this.multiple * size * 2

            result = this.GetValidCombinationsSum(ints, 5) // 获取所有有效组合的乘积和
            // this.bonus += this.multiple * result * 2
            this.bonusJS(result)
            max += this.multiple * 500000 * size
            /* if (this.bonus > max) {
              this.bonus = max
            } */
            this.AddToMap('5x1', size)
            break
          case '6关':

            size = this.GetValidCombinations(ints, 6)
            this.monery += this.multiple * size * 2

            result = this.GetValidCombinationsSum(ints, 6) // 获取所有有效组合的乘积和
            // this.bonus += this.multiple * result * 2
            this.bonusJS(result)
            max += this.multiple * 1000000 * size
            /* if (this.bonus > max) {
              this.bonus = max
            } */
            this.AddToMap('6x1', size)
            break
          case '7关':

            size = this.GetValidCombinations(ints, 7)
            this.monery += this.multiple * size * 2

            result = this.GetValidCombinationsSum(ints, 7) // 获取所有有效组合的乘积和
            // this.bonus += this.multiple * result * 2
            this.bonusJS(result)
            this.AddToMap('7x1', size)
            break
          case '8关':

            size = this.GetValidCombinations(ints, 8)
            this.monery += this.multiple * size * 2

            result = this.GetValidCombinationsSum(ints, 8) // 获取所有有效组合的乘积和
            // this.bonus += this.multiple * result * 2
            this.bonusJS(result)
            this.AddToMap('8x1', size)
            break
          default: break
        }
        /* if (this.bonus > max && this.count <= 5) {
          this.bonus = max
        } */
      }
      /* if (this.bonus > max) {
        this.bonus = max
      } */
    },
    MNjs () {
      let ints = this.getResIns()
      let size = 0
      let size2 = 0
      let size3 = 0
      let size4 = 0
      let size5 = 0
      let size6 = 0
      let size7 = 0
      let result = 0
      let result2 = 0
      let result3 = 0
      let result4 = 0
      let result5 = 0
      let result6 = 0
      let result7 = 0
      let max = 0
      switch (this.selectedMN) {
        case '2x1':
          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2
          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)

          max = this.multiple * 200000

          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('2x1', size)
          break
        case '3x1':

          size = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)

          max = this.multiple * 200000
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('3x1', size)
          break
        case '4x1':

          size = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)

          max = this.multiple * 500000
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('4x1', size)
          break
        case '5x1':

          size = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 5)

          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)

          max = this.multiple * 500000
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('5x1', size)
          break
        case '6x1':

          size = this.GetValidCombinations(ints, 6)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 6)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * 1000000
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('6x1', size)
          break
        case '7x1':

          size = this.GetValidCombinations(ints, 7)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 7)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)

          this.AddToMap('7x1', size)
          break
        case '8x1':

          size = this.GetValidCombinations(ints, 8)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 8)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)

          this.AddToMap('8x1', size)
          break
        case '3x3':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * 200000 * size
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('2x1', size)
          break
        case '3x4':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2

          size2 = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size2 * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2

          this.bonusJS(result)

          result2 = this.GetValidCombinationsSum(ints, 3)

          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          max = this.multiple * 200000 * (size + size2)
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('2x1', size)
          this.AddToMap('3x1', size2)
          break
        case '4x4':

          size = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)

          max = this.multiple * 200000 * size
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('3x1', size)
          break
        case '4x5':

          size = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size * 2

          size2 = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size2 * 2

          result = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)

          max = this.multiple * (200000 * size + 500000 * size2)
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('3x1', size)
          this.AddToMap('4x1', size2)
          break
        case '4x6':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)

          max = this.multiple * 200000 * size
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('2x1', size)
          break
        case '4x11':
          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size2 * 2
          size3 = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size3 * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)

          result2 = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)

          result3 = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result3 * 2
          this.bonusJS(result3)

          max = this.multiple * (200000 * size + 200000 * size2 + 500000 * size3)
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('2x1', size)
          this.AddToMap('3x1', size2)
          this.AddToMap('4x1', size3)
          break
        case '5x5':

          size = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * (500000 * size)
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('4x1', size)
          break
        case '5x6':

          size = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size2 * 2

          result = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          max = this.multiple * (500000 * (size+size2))
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('4x1', size)
          this.AddToMap('5x1', size2)
          break
        case '5x10':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * (200000 * size)
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('2x1', size)
          break
        case '5x16':

          size = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size2 * 2
          size3 = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size3 * 2

          result = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          result3 = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result3 * 2
          this.bonusJS(result3)

          max = this.multiple * (200000 * size + 500000 * size2 + 500000 * size3)
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('3x1', size)
          this.AddToMap('4x1', size2)
          this.AddToMap('5x1', size3)
          break
        case '5x20':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size2 * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          max = this.multiple * (200000 * (size+size2))
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('2x1', size)
          this.AddToMap('3x1', size2)
          break
        case '5x26':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size2 * 2
          size3 = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size3 * 2
          size4 = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size4 * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          result3 = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result3 * 2
          this.bonusJS(result3)
          result4 = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result4 * 2
          this.bonusJS(result4)

          max = this.multiple * (200000 * size + 200000 * size2 + 500000 * size3 + 500000 * size4)
          /* if (this.bonus > max) {
            this.bonus = max
          } */

          this.AddToMap('2x1', size)
          this.AddToMap('3x1', size2)
          this.AddToMap('4x1', size3)
          this.AddToMap('5x1', size4)
          break
        case '6x6':

          size = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * 500000 * size
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('5x1', size)
          break
        case '6x7':

          size = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 6)
          this.monery += this.multiple * size2 * 2

          result = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 6)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          max = this.multiple * (500000 * size + 1000000 * size2)
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('5x1', size)
          this.AddToMap('6x1', size2)
          break
        case '6x15':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * (200000 * size)
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('2x1', size)
          break
        case '6x20':

          size = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * (200000 * size)
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('3x1', size)
          break
        case '6x22':

          size = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size2 * 2
          size3 = this.GetValidCombinations(ints, 6)
          this.monery += this.multiple * size3 * 2

          result = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          result3 = this.GetValidCombinationsSum(ints, 6)

          // this.bonus += this.multiple * result3 * 2
          this.bonusJS(result3)

          max = this.multiple * (500000 * size + 500000 * size2 + 1000000 * size3)
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('4x1', size)
          this.AddToMap('5x1', size2)
          this.AddToMap('6x1', size3)
          break
        case '6x35':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size2 * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          max = this.multiple * (200000 * size + 200000 * size2)
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('2x1', size)
          this.AddToMap('3x1', size2)
          break
        case '6x42':

          size = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size2 * 2
          size3 = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size3 * 2
          size4 = this.GetValidCombinations(ints, 6)
          this.monery += this.multiple * size4 * 2

          result = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          result3 = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result3 * 2
          this.bonusJS(result3)
          result4 = this.GetValidCombinationsSum(ints, 6)
          // this.bonus += this.multiple * result4 * 2
          this.bonusJS(result4)
          max = this.multiple * (200000 * size + 500000 * size2 + 500000 * size3 + 1000000 * size4)
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('3x1', size)
          this.AddToMap('4x1', size2)
          this.AddToMap('5x1', size3)
          this.AddToMap('6x1', size4)
          break
        case '6x50':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size2 * 2
          size3 = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size3 * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          result3 = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result3 * 2
          this.bonusJS(result3)
          max = this.multiple * (200000 * size + 200000 * size2 + 500000 * size3)
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('2x1', size)
          this.AddToMap('3x1', size2)
          this.AddToMap('4x1', size3)
          break
        case '6x57':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size2 * 2
          size3 = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size3 * 2
          size4 = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size4 * 2
          size5 = this.GetValidCombinations(ints, 6)
          this.monery += this.multiple * size5 * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          result3 = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result3 * 2
          this.bonusJS(result3)
          result4 = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result4 * 2
          this.bonusJS(result4)
          result5 = this.GetValidCombinationsSum(ints, 6)
          // this.bonus += this.multiple * result5 * 2
          this.bonusJS(result5)
          max = this.multiple * (200000 * size + 200000 * size2 + 500000 * size3 + 500000 * size4 + 1000000 * size5)
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('2x1', size)
          this.AddToMap('3x1', size2)
          this.AddToMap('4x1', size3)
          this.AddToMap('5x1', size4)
          this.AddToMap('6x1', size5)
          break
        case '7x7':

          size = this.GetValidCombinations(ints, 6)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 6)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * (1000000 * size)
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('6x1', size)
          break
        case '7x8':

          size = this.GetValidCombinations(ints, 6)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 7)
          this.monery += this.multiple * size2 * 2

          result = this.GetValidCombinationsSum(ints, 6)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 7)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          /* max = this.multiple * (1000000 * (size + size2))
          if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('6x1', size)
          this.AddToMap('7x1', size2)
          break
        case '7x21':

          size = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * (500000 * size)
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('5x1', size)
          break
        case '7x35':

          size = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * (500000 * size)
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('4x1', size)
          break
        case '7x120':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size2 * 2
          size3 = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size3 * 2
          size4 = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size4 * 2
          size5 = this.GetValidCombinations(ints, 6)
          this.monery += this.multiple * size5 * 2
          size6 = this.GetValidCombinations(ints, 7)
          this.monery += this.multiple * size6 * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          result3 = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result3 * 2
          this.bonusJS(result3)
          result4 = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result4 * 2
          this.bonusJS(result4)
          result5 = this.GetValidCombinationsSum(ints, 6)
          // this.bonus += this.multiple * result5 * 2
          this.bonusJS(result5)
          result6 = this.GetValidCombinationsSum(ints, 7)
          // this.bonus += this.multiple * result6 * 2
          this.bonusJS(result6)
          /* max = this.multiple * (200000 * size + 200000 * size2 + 500000 * size3 + 500000 * size4 + 1000000 * size5)
          if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('2x1', size)
          this.AddToMap('3x1', size2)
          this.AddToMap('4x1', size3)
          this.AddToMap('5x1', size4)
          this.AddToMap('6x1', size5)
          this.AddToMap('7x1', size6)
          break
        case '8x8':

          size = this.GetValidCombinations(ints, 7)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 7)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)

          this.AddToMap('7x1', size)
          break
        case '8x9':

          size = this.GetValidCombinations(ints, 7)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 8)
          this.monery += this.multiple * size2 * 2

          result = this.GetValidCombinationsSum(ints, 7)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 8)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)

          this.AddToMap('7x1', size)
          this.AddToMap('8x1', size2)
          break
        case '8x28':

          size = this.GetValidCombinations(ints, 6)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 6)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * 1000000 * size
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('6x1', size)
          break
        case '8x56':

          size = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * 500000 * size
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('5x1', size)
          break
        case '8x70':

          size = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size * 2

          result = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          max = this.multiple * 500000 * size
          /* if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('4x1', size)
          break
        case '8x247':

          size = this.GetValidCombinations(ints, 2)
          this.monery += this.multiple * size * 2
          size2 = this.GetValidCombinations(ints, 3)
          this.monery += this.multiple * size2 * 2
          size3 = this.GetValidCombinations(ints, 4)
          this.monery += this.multiple * size3 * 2
          size4 = this.GetValidCombinations(ints, 5)
          this.monery += this.multiple * size4 * 2
          size5 = this.GetValidCombinations(ints, 6)
          this.monery += this.multiple * size5 * 2
          size6 = this.GetValidCombinations(ints, 7)
          this.monery += this.multiple * size6 * 2
          size7 = this.GetValidCombinations(ints, 8)
          this.monery += this.multiple * size7 * 2

          result = this.GetValidCombinationsSum(ints, 2)
          // this.bonus += this.multiple * result * 2
          this.bonusJS(result)
          result2 = this.GetValidCombinationsSum(ints, 3)
          // this.bonus += this.multiple * result2 * 2
          this.bonusJS(result2)
          result3 = this.GetValidCombinationsSum(ints, 4)
          // this.bonus += this.multiple * result3 * 2
          this.bonusJS(result3)
          result4 = this.GetValidCombinationsSum(ints, 5)
          // this.bonus += this.multiple * result4 * 2
          this.bonusJS(result4)
          result5 = this.GetValidCombinationsSum(ints, 6)
          // this.bonus += this.multiple * result5 * 2
          this.bonusJS(result5)
          result6 = this.GetValidCombinationsSum(ints, 7)
          // this.bonus += this.multiple * result6 * 2
          this.bonusJS(result6)
          result7 = this.GetValidCombinationsSum(ints, 8)
          // this.bonus += this.multiple * result7 * 2
          this.bonusJS(result7)
          /* max = this.multiple * (200000 * size + 200000 * size2 + 500000 * size3 + 500000 * size4 + 1000000 * size5)
          if (this.bonus > max) {
            this.bonus = max
          } */
          this.AddToMap('2x1', size)
          this.AddToMap('3x1', size2)
          this.AddToMap('4x1', size3)
          this.AddToMap('5x1', size4)
          this.AddToMap('6x1', size5)
          this.AddToMap('7x1', size6)
          this.AddToMap('8x1', size7)
          break
        default: break
      }
    },
    bonusJS (result) {
      this.bonus += this.multiple * result
      if (this.multiple > 50) {
        // this.bonusTmp += 50 * result * 2
        this.bonusTmp += 50 * result
      } else {
        // this.bonusTmp += this.multiple * result * 2
        this.bonusTmp += this.multiple * result
      }
      /* if (this.type === '足彩') {
        // this.bonus += this.multiple * result * 2
        this.bonus += this.multiple * parseFloat((result * 2).toFixed(2))
        if (this.multiple > 50) {
          // this.bonusTmp += 50 * result * 2
          this.bonusTmp += 50 * parseFloat((result * 2).toFixed(2))
        } else {
          // this.bonusTmp += this.multiple * result * 2
          this.bonusTmp += this.multiple * parseFloat((result * 2).toFixed(2))
        }
      } else if (this.type === '篮彩') {
        this.bonus += this.multiple * parseFloat((result * 2).toFixed(2))
        alert(this.bonus)
        if (this.multiple > 50) {
          this.bonusTmp += 50 * parseFloat((result * 2).toFixed(2))
        } else {
          this.bonusTmp += this.multiple * parseFloat((result * 2).toFixed(2))
        }
      } */
    },
    Djs () {
      let count = 0
      let intsd = []
      // 根据 cpTypeName 的不同，循环不同的场次数据
      if (this.cpTypeName === '足球胜平负') {
        this.selectFtOneList.forEach(item => {
          count += item.selectWinDrawLoses.length // 每个场次选中的数量
          intsd.push(item.selectWinDrawLoses.length)
        })
      }
      if (this.cpTypeName === '足球比分') {
        this.selectFtTwoList.forEach(item => {
          count += item.selectWdls.length // 每个场次选中的数量
          intsd.push(item.selectWdls.length)
        })
      }
      if (this.cpTypeName === '足球总进球数') {
        this.selectFtThreeList.forEach(item => {
          count += item.selectWdls.length // 每个场次选中的数量
          intsd.push(item.selectWdls.length)
        })
      }
      if (this.cpTypeName === '足球半全场胜平负') {
        this.selectFtFourList.forEach(item => {
          count += item.selectWdls.length // 每个场次选中的数量
          intsd.push(item.selectWdls.length)
        })
      }
      if (this.cpTypeName === '篮球胜负') {
        this.selectBtOneList.forEach(item => {
          count += item.selectWinLose.length // 每个场次选中的数量
          intsd.push(item.selectWinLose.length)
        })
      }
      if (this.cpTypeName === '篮球让分胜负') {
        this.selectBtTwoList.forEach(item => {
          count += item.selectWinLose.length // 每个场次选中的数量
          intsd.push(item.selectWinLose.length)
        })
      }
      if (this.cpTypeName === '篮球胜分差') {
        this.selectBtThreeList.forEach(item => {
          count += item.selectWinLose.length // 每个场次选中的数量
          intsd.push(item.selectWinLose.length)
        })
      }
      if (this.cpTypeName === '篮球大小分') {
        this.selectBtFourList.forEach(item => {
          count += item.selectWinLose.length // 每个场次选中的数量
          intsd.push(item.selectWinLose.length)
        })
      }
      this.monery += this.multiple * count * 2

      // 确保有效组合的计算返回值正确
      let resultd = this.GetValidCombinationsSum(intsd, 2)
      this.bonusJS(resultd)
      // 确保 multiple 是有效数字
      /* if (this.type === '足彩') {
        this.bonus += this.multiple * resultd * 2
        if (this.multiple > 50) {
          this.bonusTmp += 50 * resultd * 2
        } else {
          this.bonusTmp += this.multiple * resultd * 2
        }
      } else if (this.type === '篮彩') {
        this.bonus += this.multiple * parseFloat((resultd * 2).toFixed(2)) // this.multiple * parseFloat(resultd).toFixed(2) * 2
        if (this.multiple > 50) {
          this.bonusTmp += 50 * parseFloat((resultd * 2).toFixed(2))
        } else {
          this.bonusTmp += this.multiple * parseFloat((resultd * 2).toFixed(2))
        }
      } */
    },
    // 获取每场比赛的选中数量列表
    getResIns () {
      let ints = []
      if (this.cpTypeName === '足球胜平负') {
        this.selectFtOneList.forEach(item => {
          ints.push(item.selectWinDrawLoses.length)
        })
      } else if (this.cpTypeName === '足球比分') {
        this.selectFtTwoList.forEach(item => {
          ints.push(item.selectWdls.length)
        })
      } else if (this.cpTypeName === '足球总进球数') {
        this.selectFtThreeList.forEach(item => {
          ints.push(item.selectWdls.length)
        })
      } else if (this.cpTypeName === '足球半全场胜平负') {
        this.selectFtFourList.forEach(item => {
          ints.push(item.selectWdls.length)
        })
      } else if (this.cpTypeName === '篮球胜负') {
        this.selectBtOneList.forEach(item => {
          ints.push(item.selectWinLose.length)
        })
      } else if (this.cpTypeName === '篮球让分胜负') {
        this.selectBtTwoList.forEach(item => {
          ints.push(item.selectWinLose.length)
        })
      } else if (this.cpTypeName === '篮球胜分差') {
        this.selectBtThreeList.forEach(item => {
          ints.push(item.selectWinLose.length)
        })
      } else if (this.cpTypeName === '篮球大小分') {
        this.selectBtFourList.forEach(item => {
          ints.push(item.selectWinLose.length)
        })
      } else if (this.cpTypeName === '足球混合过关') {
        this.selectFtFiveList.forEach(item => {
          switch (item.selectType) {
            case 'one':
              ints.push(item.selectOneWinLose.length)
              break
            case 'two':
              ints.push(item.selectTwoWinLose.length)
              break
            case 'three':
              ints.push(item.selectThreeWinLose.length)
              break
            case 'four':
              ints.push(item.selectFourWinLose.length)
              break
          }
        })
      } else if (this.cpTypeName === '篮球混合过关') {
        this.selectBtFiveList.forEach(item => {
          switch (item.selectType) {
            case 'one':
              ints.push(item.selectOneWinLose.length)
              break
            case 'two':
              ints.push(item.selectTwoWinLose.length)
              break
            case 'three':
              ints.push(item.selectThreeWinLose.length)
              break
            case 'four':
              ints.push(item.selectFourWinLose.length)
              break
          }
        })
      }
      return ints
    },
    GetValidCombinationsSum (ints, k) {
      const n = ints.length // 获取行数
      const maxValues = []
      // 提取每行的最大值
      for (let i = 0; i < n; i++) {
        const rowValues = []

        if (this.cpTypeName === '足球胜平负') {
          this.selectFtOneList[i].selectWinDrawLoses.forEach((value) => {
            const match = value.match(/\d+\.\d+/)
            if (match) {
              rowValues.push(parseFloat(match[0]))
            }
          })
        }
        if (this.cpTypeName === '足球比分') {
          this.selectFtTwoList[i].selectWdls.forEach((value) => {
            rowValues.push(parseFloat(value.split(' ')[1]))
          })
        }

        if (this.cpTypeName === '足球总进球数') {
          this.selectFtThreeList[i].selectWdls.forEach((value) => {
            const match = value.match(/\d+\.\d+/)
            if (match) {
              rowValues.push(parseFloat(match[0]))
            }
          })
        }

        if (this.cpTypeName === '足球半全场胜平负') {
          this.selectFtFourList[i].selectWdls.forEach((value) => {
            const match = value.match(/\d+\.\d+/)
            if (match) {
              rowValues.push(parseFloat(match[0]))
            }
          })
        }

        if (this.cpTypeName === '篮球胜负') {
          this.selectBtOneList[i].selectWinLose.forEach((value) => {
            const match = value.match(/\d+\.\d+/)
            if (match) {
              rowValues.push(parseFloat(match[0]))
            }
          })
        }

        if (this.cpTypeName === '篮球让分胜负') {
          this.selectBtTwoList[i].selectWinLose.forEach((value) => {
            const match = value.match(/\d+\.\d+/)
            if (match) {
              rowValues.push(parseFloat(match[0]))
            }
          })
        }

        if (this.cpTypeName === '篮球胜分差') {
          this.selectBtThreeList[i].selectWinLose.forEach((value) => {
            const match = value.match(/\d+\.\d+/)
            if (match) {
              rowValues.push(parseFloat(match[0]))
            }
          })
        }

        if (this.cpTypeName === '篮球大小分') {
          this.selectBtFourList[i].selectWinLose.forEach((value) => {
            const match = value.match(/\d+\.\d+/)
            if (match) {
              rowValues.push(parseFloat(match[0]))
            }
          })
        }

        if (this.cpTypeName === '足球混合过关') {
          const ftFive = this.selectFtFiveList[i]
          if (ftFive.selectType === 'one') {
            ftFive.selectOneWinLose.forEach((value) => {
              const match = value.match(/\d+\.\d+/)
              if (match) {
                rowValues.push(parseFloat(match[0]))
              }
            })
          } else if (ftFive.selectType === 'two') {
            ftFive.selectTwoWinLose.forEach((value) => {
              rowValues.push(parseFloat(value.split(' ')[1]))
            })
          } else if (ftFive.selectType === 'three') {
            ftFive.selectThreeWinLose.forEach((value) => {
              const match = value.match(/\d+\.\d+/)
              if (match) {
                rowValues.push(parseFloat(match[0]))
              }
            })
          } else if (ftFive.selectType === 'four') {
            ftFive.selectFourWinLose.forEach((value) => {
              const match = value.match(/\d+\.\d+/)
              if (match) {
                rowValues.push(parseFloat(match[0]))
              }
            })
          }
        }

        if (this.cpTypeName === '篮球混合过关') {
          const btFive = this.selectBtFiveList[i]
          if (btFive.selectType === 'one') {
            btFive.selectOneWinLose.forEach((value) => {
              const match = value.match(/\d+\.\d+/)
              if (match) {
                rowValues.push(parseFloat(match[0]))
              }
            })
          } else if (btFive.selectType === 'two') {
            btFive.selectTwoWinLose.forEach((value) => {
              const match = value.match(/\d+\.\d+/)
              if (match) {
                rowValues.push(parseFloat(match[0]))
              }
            })
          } else if (btFive.selectType === 'three') {
            btFive.selectThreeWinLose.forEach((value) => {
              const match = value.match(/\d+\.\d+/)
              if (match) {
                rowValues.push(parseFloat(match[0]))
              }
            })
          } else if (btFive.selectType === 'four') {
            btFive.selectFourWinLose.forEach((value) => {
              const match = value.match(/\d+\.\d+/)
              if (match) {
                rowValues.push(parseFloat(match[0]))
              }
            })
          }
        }
        if (rowValues.length > 0) {
          maxValues.push(Math.max(...rowValues))
        }
      }
      if (this.selectedGToggle) {
        // 将 maxValues 中的所有最大值加起来
        // return (maxValues.reduce((sum, val) => sum + val, 0) * 2).toFixed(2)
        let result = (maxValues.reduce((sum, val) => sum + val, 0) * 2)
        return (Math.round(result * 10000) / 10000).toFixed(2)
      }

      const v = this.sumCombinations(maxValues, k, 0, [], 1)
      /* if ((k === 2 || k === 3) && v > 100000) {
        v = 100000
      } else if (k === 4 && v > 250000) {
        v = 250000
      } */
      return v
    },
    /**
     * 递归计算组合乘积的和
     * @param {Array} values - 值的列表
     * @param {Number} k - 目标组合长度
     * @param {Number} currentIndex - 当前索引
     * @param {Array} currentCombination - 当前组合
     * @param {Number} currentProduct - 当前组合的乘积
     * @returns {Number} - 所有组合乘积的和
     */
    sumCombinations (values, k, currentIndex = 0, currentCombination = [], currentProduct = 1) {
      // 当组合长度等于k时，返回组合的乘积
      if (currentCombination.length === k) {
        const roundedProduct = Math.round(currentProduct * 2 * 10000) / 10000
        // alert('v:' + roundedProduct)
        if (k === 2 || k === 3) {
          if (parseFloat(roundedProduct.toFixed(2)) > 200000) {
            return 200000
          }
        } else if (k === 4 || k === 5) {
          if (parseFloat(roundedProduct.toFixed(2)) > 500000) {
            return 500000
          }
        } else if (k === 6) {
          if (parseFloat(roundedProduct.toFixed(2)) > 1000000) {
            return 1000000
          }
        }
        // alert(parseFloat((Math.round(roundedProduct * 100) / 100).toFixed(2)))
        return parseFloat((Math.round(roundedProduct * 100) / 100).toFixed(2)) // parseFloat(roundedProduct.toFixed(2)) // currentProduct
      }

      // 如果当前索引超出范围，无法再组成有效组合
      if (currentIndex >= values.length) {
        return 0
      }

      let sum = 0
      // 从当前索引开始选择值
      for (let i = currentIndex; i < values.length; i++) {
        // 添加值到当前组合并继续递归
        currentCombination.push(values[i])
        sum += this.sumCombinations(
          values,
          k,
          i + 1,
          currentCombination,
          currentProduct * values[i]
        )
        currentCombination.pop() // 回溯
      }
      return sum
    },
    // 主方法：获取有效组合的总数量
    GetValidCombinations (rowCounts, k) {
      const n = rowCounts.length // 获取行数
      const groupedLetters = []

      // 生成字母并按行存储
      for (let i = 0; i < n; i++) {
        const row = []
        for (let j = 0; j < rowCounts[i]; j++) {
          row.push(String.fromCharCode(65 + j + i * 26)) // 生成字符 A, B, C...（动态扩展行的字母范围）
        }
        groupedLetters.push(row)
      }

      // 调用递归函数来计算组合数量
      return this.countCombinations(groupedLetters, k, 0, [])
    },

    // 递归计算组合数量
    countCombinations (groups, k, currentRow, currentCombination) {
      // 如果当前组合长度达到 k，说明已找到一个有效组合
      if (currentCombination.length === k) {
        return 1
      }

      // 如果已遍历所有行但未达到 k，说明无法再组成有效组合
      if (currentRow >= groups.length) {
        return 0
      }

      let count = 0

      // 遍历当前行的字母
      for (const letter of groups[currentRow]) {
        // 选择当前行的一个字母，并继续递归处理下一行
        currentCombination.push(letter)
        count += this.countCombinations(
          groups,
          k,
          currentRow + 1,
          currentCombination
        )
        currentCombination.pop() // 回溯
      }

      // 跳过当前行，直接进入下一行
      count += this.countCombinations(groups, k, currentRow + 1, currentCombination)

      return count
    }
  },
  watch: {
    multiple: 'updatePlayTypes',
    selectedGToggle: 'updatePlayTypes',
    selectedMN: 'updatePlayTypes',
    selectedG2: 'updatePlayTypes',
    selectedG3: 'updatePlayTypes',
    selectedG4: 'updatePlayTypes',
    selectedG5: 'updatePlayTypes',
    selectedG6: 'updatePlayTypes',
    selectedG7: 'updatePlayTypes',
    selectedG8: 'updatePlayTypes',
    selectFtOneList: {handler: 'updatePlayTypes', deep: true},
    selectFtTwoList: {handler: 'updatePlayTypes', deep: true},
    selectFtThreeList: {handler: 'updatePlayTypes', deep: true},
    selectFtFourList: {handler: 'updatePlayTypes', deep: true},
    selectFtFiveList: {handler: 'updatePlayTypes', deep: true},
    selectBtOneList: {handler: 'updatePlayTypes', deep: true},
    selectBtTwoList: {handler: 'updatePlayTypes', deep: true},
    selectBtThreeList: {handler: 'updatePlayTypes', deep: true},
    selectBtFourList: {handler: 'updatePlayTypes', deep: true},
    selectBtFiveList: {handler: 'updatePlayTypes', deep: true}
  }
}
</script>
<style scoped>
.counter-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.counter-input {
  display: flex;
  align-items: center;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  overflow: hidden;
}

.counter-input .el-button {
  margin: 0;
  border: none;
  background-color: #f5f5f5;
}

.input-field {
  text-align: center;
  width: 100px; /* 输入框宽度 */
  pointer-events: none; /* 禁止用户直接输入 */
}

.popover-options {
  display: flex;
  justify-content: space-between;
  gap: 5px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue